function PlayIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="#4079F5" {...props}>
      <path d="M8 1.334a6.67 6.67 0 00-6.667 6.667A6.669 6.669 0 008 14.667a6.669 6.669 0 006.667-6.666A6.67 6.67 0 008 1.334zm-1.333 9.667V5l4 3-4 3z" />
    </svg>
  )
}

export default PlayIcon
